export default __webpack_public_path__ + "static/media/ezeetunai-home.1485dedc.svg";